
import Vue from "vue";
import Axios from "axios";

import { router } from "@Scripts/Config/RouteConfig";
import { store } from "@Scripts/Config/StoreConfig";

import DataWebConfig from "@Scripts/Config/DataWebConfig";
import AppConfig from "@Scripts/Config/AppConfig";

import ResponsiveHelper from "@Scripts/Infrastructure/ResponsiveHelper";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account", "PrivacyPolicy", "YOURent"]
        });

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            Vue.use(DataWeb.default);
            Vue.use(DataWebConfig);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        this.initRequestVerificationToken();

        AppConfig.AddComponents();
        AppConfig.AddDirectives();

        let vm = new Vue({
            el: "#app",
            router,
            store,
            created() {
                if (DataWeb) {
                    DataWeb.default.registerRoutes(router);
                    DataWeb.default.registerStoreModules(store);
                }
            }
        });

        (<any>window).App.instances.vm = vm;

        ResponsiveHelper.onResize();

        this.resetCssAnimations();
        this.setWrapMenu();
        this.onLoad();
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static resetCssAnimations() {
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static onLoad() {
        (<any>window).addEventListener("load", function () {
            document.getElementById("body")?.removeAttribute("data-preload");
        });
    }

    private static setWrapMenu() {
        let app = document.getElementById("body"),
            header = document.getElementById("Header"),
            button = document.getElementById("WrapButton");

        button?.addEventListener("click", function () {
            app.classList.toggle("overflow");
            header.classList.toggle("menu-show");
            this.classList.toggle("active");
        });
    }
}